// import React from "react";

// const facilities = [
//   {
//     id: 1,
//     title: "Discount at Golf View Restaurant",
//     desc: "Members can avail discount at the Golf View Restaurant, making dining more enjoyable and affordable.",
//   },
//   {
//     id: 2,
//     title: "Guest Room Facilities",
//     desc: "Members have access to guest room facilities for a comfortable stay within the club premises.",
//   },
//   {
//     id: 3,
//     title: "Golf without Fair Fee",
//     desc: "Members can enjoy playing golf without a fair and reduced fee, encouraging more participation.",
//   },
//   {
//     id: 4,
//     title: "Discount at Pro Shop",
//     desc: "Members can avail discounts at the Pro Shop on golfing essentials and accessories.",
//   },
// ];

// const FacilitiesForMembers = () => {
//   return (
//     <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
//       {/* Page Title */}
//       <h1 className="text-3xl sm:text-4xl font-bold text-center mb-10 text-green-700">
//         Facilities for Members
//       </h1>

//       {/* Timeline */}
//       <div className="relative max-w-3xl mx-auto border-l border-green-300">
//         {facilities.map((facility) => (
//           <div key={facility.id} className="mb-10 ml-6">
//             {/* Circle marker */}
//             <span className="absolute -left-3 flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 bg-green-600 rounded-full ring-4 ring-white text-white text-xs sm:text-sm font-bold">
//               {facility.id}
//             </span>

//             {/* Content Card */}
//             <div className="p-4 sm:p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition">
//               <h2 className="text-lg sm:text-xl font-semibold text-green-700">
//                 {facility.title}
//               </h2>
//               <p className="mt-2 text-sm sm:text-base text-gray-700 leading-relaxed">
//                 {facility.desc}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default FacilitiesForMembers;

import React, { use, useEffect, useRef } from "react";
import {
  Crown,
  Bed,
  Flag,
  Sparkles,
  CheckCircle,
  ArrowRight,
  Star,
  Percent,
  Award,
  Gift,
  Users,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const facilities = [
  {
    id: 1,
    title: "Discount at Golf View Restaurant",
    desc: "Members can avail discount at the Golf View Restaurant, making dining more enjoyable and affordable.",
    icon: <Percent className="w-6 h-6" />,
    color: "from-amber-500 to-orange-500",
    bg: "bg-gradient-to-br from-amber-50 to-orange-50",
    border: "border-amber-100",
    discount: "25% OFF",
    features: [
      "Member-only pricing",
      "Priority reservations",
      "Seasonal offers",
    ],
  },
  {
    id: 2,
    title: "Guest Room Facilities",
    desc: "Members have access to guest room facilities for a comfortable stay within the club premises.",
    icon: <Bed className="w-6 h-6" />,
    color: "from-blue-500 to-indigo-500",
    bg: "bg-gradient-to-br from-blue-50 to-indigo-50",
    border: "border-blue-100",
    discount: "Complimentary Access",
    features: ["Priority booking", "Family stays", "Extended hours"],
  },
  {
    id: 3,
    title: "Golf without Fair Fee",
    desc: "Members can enjoy playing golf without a fair and reduced fee, encouraging more participation.",
    icon: <Flag className="w-6 h-6" />,
    color: "from-emerald-500 to-lime-500",
    bg: "bg-gradient-to-br from-emerald-50 to-lime-50",
    border: "border-emerald-100",
    discount: "No Green Fees",
    features: ["Unlimited access", "Priority tee times", "Member tournaments"],
  },
  {
    id: 4,
    title: "Discount at Pro Shop",
    desc: "Members can avail discounts at the Pro Shop on golfing essentials and accessories.",
    icon: <Gift className="w-6 h-6" />,
    color: "from-purple-500 to-pink-500",
    bg: "bg-gradient-to-br from-purple-50 to-pink-50",
    border: "border-purple-100",
    discount: "20% OFF",
    features: ["Exclusive brands", "Member previews", "Seasonal sales"],
  },
];

const FacilitiesForMembers = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-lime-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-50"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-300/20 to-lime-300/20 backdrop-blur-sm border-2 border-emerald-300/30 flex items-center justify-center shadow-2xl">
                <Crown className="w-10 h-10 text-white" />
              </div>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Exclusive{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Member Privileges</span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-400 to-lime-400 -rotate-1"></span> */}
            </span>
          </h1>

          <p className="text-xl text-emerald-100 max-w-3xl mx-auto mb-8">
            Experience premium benefits and exclusive facilities designed
            specifically for our valued members
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6">
            <div className="flex items-center gap-2 text-emerald-200">
              <Star className="w-5 h-5" />
              <span>VIP Access</span>
            </div>
            <div className="w-1 h-1 bg-emerald-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-emerald-200">
              <Gift className="w-5 h-5" />
              <span>Exclusive Discounts</span>
            </div>
            <div className="w-1 h-1 bg-emerald-300 rounded-full"></div>
            <div className="flex items-center gap-2 text-emerald-200">
              <Award className="w-5 h-5" />
              <span>Priority Services</span>
            </div>
          </div>
        </div>
      </div>

      {/* Facilities Timeline */}
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute left-8 md:left-1/2 transform md:-translate-x-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-emerald-300 via-lime-300 to-emerald-300"></div>

          {facilities.map((facility, index) => {
            const isEven = index % 2 === 0;

            return (
              <div
                key={facility.id}
                className="relative mb-16 md:mb-24 last:mb-0"
              >
                {/* Timeline Dot with Discount Badge */}
                <div className="absolute left-0 md:left-1/2 transform -translate-x-1/2 z-10">
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-md opacity-50"></div>
                    <div className="relative w-16 h-16 rounded-full bg-white border-4 border-emerald-500 flex items-center justify-center shadow-2xl">
                      <div className="text-emerald-600">{facility.icon}</div>
                    </div>

                    {/* Discount Badge */}
                    {/* <div className="absolute -top-3 -right-3 px-3 py-1.5 rounded-full bg-gradient-to-r from-amber-500 to-orange-500 text-white text-xs font-bold shadow-lg">
                      {facility.discount}
                    </div> */}

                    <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 px-3 py-1 bg-emerald-500 text-white text-sm font-bold rounded-full shadow-lg">
                      {facility.id}
                    </div>
                  </div>
                </div>

                {/* Content Card */}
                <div
                  className={`ml-20 md:ml-0 md:w-5/12 ${
                    isEven ? "md:mr-auto md:pr-12" : "md:ml-auto md:pl-12"
                  }`}
                >
                  <div
                    className={`${facility.bg} ${facility.border} rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-2 overflow-hidden group`}
                  >
                    {/* Discount Banner */}
                    <div className="absolute top-0 right-0">
                      <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-2 text-sm font-bold shadow-lg transform translate-x-2 -translate-y-2 rotate-12">
                        MEMBER EXCLUSIVE
                      </div>
                    </div>

                    {/* Icon Badge */}
                    <div
                      className={`w-16 h-16 rounded-xl ${facility.bg} flex items-center justify-center mb-6 border ${facility.border} shadow-lg`}
                    >
                      <div
                        className={`bg-gradient-to-r ${facility.color} bg-clip-text text-transparent`}
                      >
                        {facility.icon}
                      </div>
                    </div>

                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                      {facility.title}
                    </h2>

                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {facility.desc}
                    </p>

                    {/* Features List */}
                    <div className="mb-6">
                      <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">
                        <Sparkles className="w-4 h-4 text-emerald-500" />
                        Member Benefits
                      </h4>
                      <ul className="space-y-2">
                        {facility.features.map((feature, idx) => (
                          <li
                            key={idx}
                            className="flex items-center gap-3 text-gray-600"
                          >
                            <CheckCircle className="w-4 h-4 text-emerald-500 flex-shrink-0" />
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Action Button */}
                    <button className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-800 font-medium group/btn transition-colors duration-300">
                      <span>Learn more about member benefits</span>
                      <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Membership Benefits Summary */}
        <div className="mt-20 grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 border border-emerald-100 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center mb-6">
              <Users className="w-7 h-7 text-emerald-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Community</h3>
            <p className="text-gray-600">
              Join an exclusive network of golf enthusiasts and professionals
            </p>
          </div>
          <div className="bg-white rounded-2xl p-8 border border-emerald-100 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center mb-6">
              <Award className="w-7 h-7 text-amber-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Recognition
            </h3>
            <p className="text-gray-600">
              Enjoy VIP status and recognition within the RGCC community
            </p>
          </div>
          <div className="bg-white rounded-2xl p-8 border border-emerald-100 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center mb-6">
              <Star className="w-7 h-7 text-blue-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Exclusivity
            </h3>
            <p className="text-gray-600">
              Access member-only events and premium facilities
            </p>
          </div>
        </div>

        {/* Membership CTA */}
        <div className="mt-16 bg-gradient-to-r from-emerald-500 to-lime-500 rounded-2xl p-10 text-white text-center shadow-2xl">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold mb-6">
              Ready to Access Premium Member Benefits?
            </h3>
            <p className="text-emerald-100 text-lg mb-8">
              Join RGCC today and unlock exclusive privileges, discounts, and
              premium facilities designed for our valued members.
            </p>
            <button
              onClick={() => navigate("/membership")}
              className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-bold bg-white text-emerald-600 hover:bg-emerald-50 hover:scale-105 transition-all duration-300 shadow-lg"
            >
              <Crown className="w-5 h-5" />
              Become a Member Today
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacilitiesForMembers;
